<ng-container>
    <button data-cy="show-template-dialog" pButton class="p-button-raised p-button-text cbms-row-button" (click)="showTemplateDialog()"
            pTooltip="Show Schedule" showDelay="1000" hideDelay="500">
        <mat-icon svgIcon="schedule"></mat-icon>
    </button>
</ng-container>
